'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { Collapse, Expand } from '@repo/ui/icons';
import { memo } from 'react';
export interface DashboardSizeButtonProps {
  isExpanded: boolean;
  isHovered: boolean;
}
const DashboardSizeButton = t0 => {
  const $ = _c(9);
  const {
    isExpanded,
    isHovered
  } = t0;
  const t1 = isHovered ? "bg-muted text-foreground" : "text-secondary-foreground";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex rounded-[50%] w-[48px] h-[48px] justify-center items-center", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      transition: "background-color 0.05s ease-in-out"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isExpanded || $[4] !== isHovered) {
    t4 = isExpanded ? <Collapse isExpanded={!isHovered} /> : <Expand isExpanded={isHovered} />;
    $[3] = isExpanded;
    $[4] = isHovered;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className={t2} style={t3}>{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default memo(DashboardSizeButton);